import React from "react";

const Placeholder = ({ title = "Coming Soon", description = "This page is under construction." }) => {
    return (
        <div className="dc-dashboardbox dc-dashboardtabsholder" style={{ padding: '2rem' }}>
            <div className="dc-dashboardboxtitle"><h2>{title}</h2></div>
            <div className="dc-emptydata-holder">
                <div className="dc-emptydata">
                    <div className="dc-emptydetails dc-empty-booking dc-emptyholder-sm">
                        <span></span>
                        <em>{description}</em>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Placeholder;


